const config = {
    REACT_APP_API_URL: process.env.REACT_APP_API_URL || '${EINV_FRONT_API_URL}',
    REACT_APP_AUTH0_DOMAIN: process.env.REACT_APP_AUTH0_DOMAIN || '${EINV_FRONT_AUTH0_DOMAIN}',
    REACT_APP_AUTH0_CLIENT: process.env.REACT_APP_AUTH0_CLIENT || '${EINV_FRONT_AUTH0_CLIENT}',
    REACT_APP_AUTH0_API: process.env.REACT_APP_AUTH0_API || '${EINV_FRONT_AUTH0_API}',
    REACT_APP_AUTH0_ORG: process.env.REACT_APP_AUTH0_ORG || '${EINV_FRONT_AUTH0_ORG}',
    REACT_APP_GA_MEASUREMENT_ID: process.env.REACT_APP_GA_MEASUREMENT_ID || '${EINV_FRONT_GA_MEASUREMENT_ID}',
};

export default config;